import React, { useState } from 'react';
import { Container, Typography, Box, Tabs, Tab, Paper } from '@mui/material';
import HandymanIcon from '@mui/icons-material/Handyman';
import { pageTitleSx } from '../styles/uiTokens';
import ManutencaoLocalManager from '../components/ManutencaoLocalManager';
import TipoEquipamentoManager from '../components/TipoEquipamentoManager';
import EquipamentoManager from '../components/EquipamentoManager';

function TabPanel({ value, index, children }) {
  return (
    <Box role="tabpanel" hidden={value !== index} sx={{ pt: 2 }}>
      {value === index && children}
    </Box>
  );
}

function CadastrosManutencaoPage() {
  const [tab, setTab] = useState(0);

  return (
    <Container sx={{ mt: 4 }} maxWidth="lg">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom sx={pageTitleSx}>
          Cadastros de manuten&ccedil;&atilde;o
        </Typography>
      </Box>

      <Paper sx={{ p: 2 }}>
        <Tabs
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab icon={<HandymanIcon fontSize="small" />} iconPosition="start" label="Locais" />
          <Tab label="Tipos de Equipamento" />
          <Tab label="Equipamentos" />
        </Tabs>

        <TabPanel value={tab} index={0}>
          <ManutencaoLocalManager />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <TipoEquipamentoManager />
        </TabPanel>
        <TabPanel value={tab} index={2}>
          <EquipamentoManager />
        </TabPanel>
      </Paper>
    </Container>
  );
}

export default CadastrosManutencaoPage;
